import { render, staticRenderFns } from "./GoodsGroup.vue?vue&type=template&id=491d80a8&scoped=true&"
import script from "./GoodsGroup.vue?vue&type=script&lang=js&"
export * from "./GoodsGroup.vue?vue&type=script&lang=js&"
import style0 from "./GoodsGroup.vue?vue&type=style&index=0&id=491d80a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491d80a8",
  null
  
)

export default component.exports